<template>
  <v-card>
    <v-card-title>Выберите продукт</v-card-title>
    <v-card-text style="max-height: 400px; overflow-y: auto">
      <v-list>
        <v-list-item
          class="pa-0 ma-0"
          v-for="item in groups"
          :key="item.id"
        >
          <v-list-item-content>
            <v-list-item-title class="mb-4 text-h5 font-weight-bold">{{
              item.name
            }}</v-list-item-title>
            <v-col
              v-for="(product, index) in item.products"
              :key="index"
            >
              <ProductCell
                :product="product"
                @click="select(product)"
              />
            </v-col>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>

    <v-card-actions>
      <div></div>
    </v-card-actions>
  </v-card>
</template>

<script>
  import ProductCell from './ProductCell.vue'

  export default {
    name: 'ProductsSelectionDialog',
    components: { ProductCell },
    props: {
      selectedProducts: [],
      select: {
        type: Function,
        required: true
      }
    },
    computed: {
      groups() {
        const excludedProductsIdSet = new Set(this.selectedProducts)
        return this.$productGroup.list
          .filter(e => e.id !== this.$productGroup.item.id)
          .map(group => ({
            ...group,
            products: group.products.filter(p => !excludedProductsIdSet.has(p.id))
          }))
          .filter(group => group.products.length > 0)
      }
    }
  }
</script>
